export enum KanbanTemplates {
  DEFAULT = "DEFAULT",
  SALES = "SALES",
  CUSTOMER_SUPPORT = "CUSTOMER_SUPPORT",
  MARKETING = "MARKETING",
}
